import React from "react";

/** Small label/value tile with an icon, used on detail pages. */
const InfoItem = ({ icon: Icon, label, value, className = "" }) => (
  <div className={`flex items-start gap-3 rounded-lg border bg-muted/30 p-3.5 ${className}`}>
    {Icon && (
      <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-accent text-accent-foreground">
        <Icon size={16} />
      </div>
    )}
    <div className="min-w-0">
      <p className="text-xs font-medium text-muted-foreground">{label}</p>
      <p className="mt-0.5 break-words text-sm font-semibold text-foreground">{value}</p>
    </div>
  </div>
);

export default InfoItem;
